import { ProductBehavior, ProductForm } from '@up2stay/up2promo-api-client';
import type {
  ProductItemInputDto,
  SetupProductDto,
} from '@up2stay/up2promo-api-client';

import { ProductType } from '../types/product-type.enum';

const BEHAVIOR_BY_SETUP_TYPE: Record<ProductType, ProductBehavior> = {
  [ProductType.GOOGLE]: ProductBehavior.GOOGLE_REVIEW,
  [ProductType.INSTAGRAM]: ProductBehavior.INSTAGRAM,
  [ProductType.MENU]: ProductBehavior.MENU,
  [ProductType.TIKTOK]: ProductBehavior.TIKTOK,
  [ProductType.FACEBOOK]: ProductBehavior.FACEBOOK,
  [ProductType.CUSTOM]: ProductBehavior.URL,
  [ProductType.BUSINESS_CARD]: ProductBehavior.PROFILE,
};

/**
 * Factory identity hint for the public setup (`item`), from the setup flow's
 * product kind (the printed `?t=` code). Business cards are PROFILE + CARD.
 * The backend only fills keys the product does not have yet.
 */
export function toSetupItem(
  type: ProductType | undefined,
): ProductItemInputDto | undefined {
  if (type == null) return undefined;
  const behavior = BEHAVIOR_BY_SETUP_TYPE[type];
  return type === ProductType.BUSINESS_CARD
    ? { behavior, form: ProductForm.CARD }
    : { behavior };
}

/** Body for `POST products-public/setup` (URL target, optional contact). */
export function buildSetupProductBody(input: {
  hash: string;
  url: string;
  type: ProductType | undefined;
  email: string | undefined;
  locale: string;
}): SetupProductDto {
  const item = toSetupItem(input.type);
  return {
    hash: input.hash,
    url: input.url,
    ...(input.email
      ? { contact: { email: input.email, locale: input.locale } }
      : {}),
    ...(item ? { item } : {}),
  };
}
